/** @format */

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Menu } from "antd";
import { connectContext } from "@/components/Context";
import { actions as authActions } from "../../reducers/userReducer";

class SlideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuData: [
        {
          text: "Discovery",
          linkPath: "discovery",
        },
        {
          text: "Profile",
          linkPath: `user/${this.props.userId}`,
        },
        {
          text: "Tag Manage",
          linkPath: "tag",
        },
        {
          text: "Setting",
          linkPath: "setting",
        },
        {
          text: "About",
          subMenu: [
            // '关于','加入我们'
            {
              text: "About",
              linkPath: "about",
            },
            {
              text: "Join Us",
              linkPath: "jobs",
            },
          ],
        },
        {
          iconType: "export",
          text: "Sign Out",
          linkPath: "logout",
        },
      ],
    };

    this.sendDustLogInstance = this.props.context.sendDustLogInstance;
  }

  handleClick = (e) => {
    //console.log('用户id'+this.props.userId);
    //console.log('click', e.keyPath[0])
    if (e.keyPath[0] === "logout") {
      // 退出登录埋点
      this.sendDustLogInstance.signOut();

      window.localStorage.removeItem("librec_paper_token");
      this.props.logout();
      this.props.history.push("/");
    } else {
      this.props.history.push(`/${e.keyPath[0]}`);
    }
  };

  render() {
    const SubMenu = Menu.SubMenu;
    return (
      <div>
        <Menu
          onClick={this.handleClick.bind(this)}
          style={{ width: 130, border: "none" }}
          mode="vertical"
        >
          {this.state.menuData.map((item, index) => {
            return item.subMenu && item.subMenu.length !== 0 ? (
              <SubMenu
                key={item.text}
                title={
                  <span>
                    <span>{item.text}</span>
                  </span>
                }
              >
                {item.subMenu.map((subItem) => {
                  return (
                    <Menu.Item key={subItem.linkPath}>{subItem.text}</Menu.Item>
                  );
                })}
              </SubMenu>
            ) : (
              <Menu.Item key={item.linkPath}>{item.text}</Menu.Item>
            );
          })}
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userImage: state.userReducer.userImage,
    userId: state.userReducer.userId,
    username: state.userReducer.username,
    email: state.userReducer.email,
    signature: state.userReducer.signature,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(authActions, dispatch);
};

export default connectContext(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SlideMenu))
);
